// extracted by mini-css-extract-plugin
export var button = "section-partner-links-module--button--74113";
export var buttonWrapper = "section-partner-links-module--buttonWrapper--835b0";
export var heading = "section-partner-links-module--heading--e7411";
export var imageWrapper = "section-partner-links-module--imageWrapper--56399";
export var partnerLink = "section-partner-links-module--partnerLink--f900b";
export var partnerLinkDummy = "section-partner-links-module--partnerLinkDummy--d9eb9";
export var partnerLinkSection = "section-partner-links-module--partnerLinkSection--47da1";
export var partnerLinks = "section-partner-links-module--partnerLinks--cf3ba";